import { render } from "./Mobile.vue?vue&type=template&id=346240cc&scoped=true&ts=true"
import script from "./Mobile.vue?vue&type=script&lang=ts"
export * from "./Mobile.vue?vue&type=script&lang=ts"

import "./Mobile.vue?vue&type=style&index=0&id=346240cc&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346240cc"]])

export default __exports__